<ng-container *ngIf="isVisible" class="loader-container">
    <div class="backdrop"></div>

    <div id="loader-wrapper">
        <div class="flex-box-spinner">
            <div id="loader"> </div>
            <div class="loader-section section-left"></div>
            <div class="loader-section section-right"></div>
            <img [src]="'images/loader.png' | environment" class="logoimg" alt="loader.png" />
        </div>
    </div>

    <div *ngIf="message" class="embedded-loader-text">
        <p>{{ message }}</p>
    </div>
</ng-container>